"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateSearchId = generateSearchId;

var _uuid = require("uuid");

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generates a new searchID (v4 UUID) if a search query string has changed from the previously held value in the state.
 * @param state Redux state
 * @param newQuery The new query value
 * @returns V.4 UUID
 */
function generateSearchId(state, newQuery) {
    var searchId = void 0;
    if (state && state.searchQuery != newQuery) {
        searchId = _uuid2.default.v4();
    } else {
        searchId = state.searchId;
    }
    return searchId;
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/helpers/search-helper.js
// module id = 787
// module chunks = 0